/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState } from '@modules/ui-types'

import { isPhoneHomeEnabled } from '@/reducers/phoneHomeConfig'
import { getPhoneHomeConfigRequest } from '@/reducers/asyncRequests/registry'

import { updatePhoneHomeIsEnabled, fetchPhoneHomeIsEnabled } from '../../../actions/phoneHome'

import PhoneHome from './PhoneHomeConfig'

interface StateProps {
  isPhoneHomeEnabled: boolean
  phoneHomeConfigRequest: AsyncRequestState
}

interface DispatchProps {
  fetchPhoneHomeIsEnabled: () => void
  updatePhoneHomeIsEnabled: (enabled: boolean) => void
}

interface ConsumerProps {}

const mapStateToProps = (state): StateProps => ({
  isPhoneHomeEnabled: isPhoneHomeEnabled(state),
  phoneHomeConfigRequest: getPhoneHomeConfigRequest(state),
})

const mapDispatchToProps: DispatchProps = {
  updatePhoneHomeIsEnabled,
  fetchPhoneHomeIsEnabled,
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(PhoneHome)
